import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { GetAttachmentUrlResponse } from '../models/email/get-attachment-url-response.model';
import { SendEmailRequest } from '../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private baseUrl: string;
  private applicationName: string;

  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigSettings,
  ) {
    this.baseUrl = this.appConfig.getconfig('emailServiceUrl');
    this.applicationName = this.appConfig.getconfig('application');
  }

  public getAttachmentsUrl(
    tenantId: string,
    numberOfAttachments: number,
  ): Observable<GetAttachmentUrlResponse[]> {
    return this.httpClient.get<GetAttachmentUrlResponse[]>(
      `${this.baseUrl}/v2/tenants/${tenantId}/attachments?applicationName=${
        this.applicationName
      }&numberOfAttachments=${encodeURIComponent(numberOfAttachments)}`,
    );
  }

  public uploadAttachment(
    uploadUrl: string,
    attachmentContent: ArrayBuffer,
  ): Observable<void> {
    return this.httpClient.put<void>(uploadUrl, attachmentContent, {
      headers: {
        'Content-Type': '' /* IMPORTANT! KEEP BLANK, else 403 FORBIDDEN*/,
        'x-amz-server-side-encryption': 'AES256',
      },
    });
  }

  public sendEmail(
    tenantId: string,
    emailRequest: SendEmailRequest,
  ): Observable<{ emailId: string }> {
    return this.httpClient.put<{ emailId: string }>(
      `${this.baseUrl}/v2/tenants/${tenantId}/sendemail`,
      emailRequest,
    );
  }
}
